import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2, Text } from '@blueprint/ui';

type HomeWorthProps = {
    isLoggedIn: boolean;
};

export const Wrapper = styled('div')<HomeWorthProps>((props) => {
    const {
        theme: { mediaQueries },
        isLoggedIn
    } = props;
    return css`
        width: 100%;
        display: flex;
        flex-direction: column;

        ${mediaQueries.large} {
            margin-right: ${isLoggedIn ? '0' : '12px'};
            flex-direction: ${isLoggedIn ? 'row-reverse' : 'column'};
            max-width: ${isLoggedIn ? '100%' : '721px'};
        }
    `;
});

export const Image = styled('img')<HomeWorthProps>((props) => {
    const {
        theme: { mediaQueries }
    } = props;
    return css`
        display: flex;

        ${mediaQueries.large} {
            width: ${props.isLoggedIn ? '50%' : '100%'};
        }
    `;
});

export const MainContent = styled('div')<HomeWorthProps>((props) => {
    const {
        theme: { mediaQueries, spacing }
    } = props;

    return css`
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: ${spacing['16px']};

        ${mediaQueries.large} {
            padding: ${spacing['24px']};
            width: ${props.isLoggedIn ? '50%' : '75%'};
        }
    `;
});

export const Heading = styled(Heading2)(({ theme: { spacing } }) => {
    return css`
        margin-bottom: ${spacing['24px']};
    `;
});

export const Description = styled(Text)(({ theme: { spacing } }) => {
    return css`
        margin-bottom: ${spacing['24px']};
    `;
});
